module.exports = __webpack_public_path__ + "static/feature_colorado_lake-899bb06512a88011378cd40e1622fb7e.jpg";